module.exports = __webpack_public_path__ + "static/media/facebook.99e53b17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/facebook.svg
// module id = 485
// module chunks = 0